import * as React from 'react';
import AnimatedHintCtrl from '@webapp/controllers/animated-hint';
import { Translate } from 'react-localize-redux';

import EXCLUDED_TITLES from './excluded';

interface CleanTitleHintCtrlProps {
  className?: string;
  title: string;
  noBorderBottom?: boolean;
}

export const isTitleClean = (title: string) => {
  const isTitleDirty = EXCLUDED_TITLES.some((excluded) => {
    return title.toLowerCase().includes(excluded.toLowerCase());
  });

  return !isTitleDirty;
};

export const CleanTitleHintCtrl: React.FC<CleanTitleHintCtrlProps> = (
  props
) => {
  const isClean = isTitleClean(props.title);

  if (isClean) {
    return null;
  }

  return (
    <AnimatedHintCtrl
      className={props.className}
      noMargin
      noBorderTop
      noBorderBottom={props.noBorderBottom}
    >
      <Translate id="RELEASE.TITLE_DIRTY" />
    </AnimatedHintCtrl>
  );
};

export default CleanTitleHintCtrl;
